import React from 'react';
import { IVenue } from 'btdt-types';
import useEventListener from '../../../helpers/useEventListener';
import VenueRelations from './VenueRelations/VenueRelations';
import './VenueRelationsModalTrigger.css';

interface IProps {
  venue: IVenue;
}

function VenueRelationsModalTrigger({ venue }: IProps): React.ReactElement | null {

  const [isOpen, setIsOpen] = React.useState(false);

  useEventListener('keydown', (event: Event) => {
    const keyboardEvent = event as KeyboardEvent;
    if (isOpen && keyboardEvent.key === 'Escape') {
      setIsOpen(false);
    }
  });

  return (
    <>
      <button onClick={() => setIsOpen(true)}>{venue.relatedVenues?.length} קשורים</button>
      {isOpen && (
        <div className="modal-overlay">
          <div className="venue-relations-modal-content">
            <VenueRelations venue={venue} />
            <button type="button" onClick={() => setIsOpen(false)}>סיימתי</button>
          </div>
        </div>
      )}
    </>
  )
}

export default VenueRelationsModalTrigger;
